import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/arrowDown.svg';

export const IconArrowDown = createIconComponent(Icon);
